import React from "react";

/**
 * AK HAS kaynagi secimi + Sapma modu + Fallback banner
 * Backend: GET/POST /api/admin/ak-carpan/settings
 */
const HasSourceConfig = ({
  hasSource,
  divergenceMode,
  lastDivergence,
  autoMarjAdj,
  fallback,
  ozanHealth = {},
  onChangeHasSource,
  onChangeDivergenceMode,
}) => (
  <div style={{ background: '#e4e4e4', borderRadius: 10, padding: 14, marginBottom: 12, border: '1px solid #e5e7eb' }}>
    {/* Ozan proxy saglik rozeti */}
    {(() => {
      const st = ozanHealth.status;
      if (!st || st === 'unknown') return null;
      const ok = st === 'ok';
      return (
        <div data-testid="ozan-proxy-health-badge"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 999,
                   marginBottom: 10, fontSize: 11, fontWeight: 700,
                   background: ok ? '#dcfce7' : '#fee2e2', color: ok ? '#166534' : '#991b1b',
                   border: '1px solid ' + (ok ? '#86efac' : '#fca5a5') }}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: ok ? '#22c55e' : '#ef4444' }} />
          {ok ? 'Ozan bağlantısı aktif (proxy)' : 'Ozan bağlantısı YOK (proxy yanıt vermiyor)'}
          {ozanHealth.proxy_host ? (
            <span data-testid="ozan-proxy-host" style={{ marginLeft: 4, fontWeight: 600, opacity: 0.8, fontFamily: 'monospace' }}>
              • {ozanHealth.proxy_host}
            </span>
          ) : null}
        </div>
      );
    })()}

    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
      <div>
        <h3 style={{ margin: 0, color: '#09301E', fontSize: 14 }}>💠 HAS Altın Kaynağı</h3>
        <p style={{ fontSize: 11, color: '#64748b', margin: '4px 0 0' }}>
          Hangi siteden HAS fiyatı çekilsin? <strong>Çarpanlar Ozan'dan</strong> öğrenilmeye devam eder. Altınkaynak 4sn yanıt vermezse otomatik Ozan'a geçer (10dk).
        </p>
      </div>
      <div style={{ display: 'flex', gap: 0, background: '#f1f5f9', padding: 4, borderRadius: 8 }}>
        <button onClick={() => onChangeHasSource('altinkaynak')} data-testid="ak-has-source-altinkaynak"
          style={{ padding: '9px 16px', fontSize: 12, fontWeight: 700, borderRadius: 6, border: 'none', cursor: 'pointer',
                   background: hasSource === 'altinkaynak' ? '#DA9F54' : 'transparent',
                   color: hasSource === 'altinkaynak' ? '#000' : '#475569' }}>
          Altınkaynak (1sn)
        </button>
        <button onClick={() => onChangeHasSource('ozan')} data-testid="ak-has-source-ozan"
          style={{ padding: '9px 16px', fontSize: 12, fontWeight: 700, borderRadius: 6, border: 'none', cursor: 'pointer',
                   background: hasSource === 'ozan' ? '#DA9F54' : 'transparent',
                   color: hasSource === 'ozan' ? '#000' : '#475569' }}>
          Ozan (3sn)
        </button>
      </div>
    </div>

    {/* Sapma Modu Selector + Banner */}
    <div style={{ marginTop: 10, padding: 10, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 6 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Sapma Modu:</div>
        <div style={{ display: 'flex', gap: 6 }}>
          {[
            { id: 'off', label: '⛔ Kapalı', testid: 'div-mode-off-btn' },
            { id: 'fallback', label: '🛡️ Fallback', testid: 'div-mode-fallback-btn' },
            { id: 'auto_marj', label: '⚙️ Oto Marj', testid: 'div-mode-auto-marj-btn' },
          ].map(opt => (
            <button key={opt.id} onClick={() => onChangeDivergenceMode(opt.id)} data-testid={opt.testid}
              style={{ padding: '6px 12px', borderRadius: 5, cursor: 'pointer', fontWeight: 600, fontSize: 12,
                border: '1.5px solid ' + (divergenceMode === opt.id ? '#DA9F54' : '#cbd5e1'),
                background: divergenceMode === opt.id ? '#DA9F54' : 'transparent',
                color: divergenceMode === opt.id ? '#000' : '#475569' }}>
              {opt.label}
            </button>
          ))}
        </div>
      </div>
      <div style={{ fontSize: 11, color: '#64748b', marginTop: 6 }}>
        {divergenceMode === 'off' ? (
          <span style={{ color: '#ef4444', fontWeight: 600 }}>⛔ Sapma kontrolü kapalı — Ozan'a istek atılmıyor</span>
        ) : (
          <>
            Son kontrol: Alış fark <strong>{(lastDivergence.diff_alis || 0).toFixed(2)} TL</strong> / Satış fark <strong>{(lastDivergence.diff_satis || 0).toFixed(2)} TL</strong>
            <span style={{ marginLeft: 8, color: '#64748b' }}>
              {divergenceMode === 'fallback' ? '• Fallback: fark ≥ 5 TL olunca Ozan\'a 10 dk geçer' : '• Oto Marj: LİMİTSİZ — her farkı anında Ozan\'a hizalar'}
            </span>
            {divergenceMode === 'auto_marj' && (autoMarjAdj.alis || autoMarjAdj.satis) ? (
              <span style={{ marginLeft: 8, color: '#0ea5e9', fontWeight: 600 }}>
                • Aktif Düzeltme: Alış {autoMarjAdj.alis >= 0 ? '+' : ''}{autoMarjAdj.alis} / Satış {autoMarjAdj.satis >= 0 ? '+' : ''}{autoMarjAdj.satis}
              </span>
            ) : null}
          </>
        )}
      </div>
    </div>

    {/* Ozan proxy DOWN uyari banner'i */}
    {ozanHealth.status === 'down' && (
      <div data-testid="ozan-proxy-down-banner" style={{ marginTop: 10, padding: '10px 12px', background: '#fee2e2', border: '1.5px solid #ef4444', borderRadius: 6, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 18 }}>🔴</span>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#991b1b' }}>Ozan proxy yanıt vermiyor</div>
          <div style={{ fontSize: 11, color: '#7f1d1d', marginTop: 2 }}>
            {ozanHealth.proxy_configured
              ? 'Proxy üzerinden Ozan sitesine ulaşılamıyor. Çoğunlukla Ozan (ozandoviz.com) geçici olarak yanıt vermiyordur; nadiren proxy (IPRoyal) aboneliği bitmiş olabilir. Ana fiyatlar Altınkaynak\'tan gelmeye devam eder.'
              : 'Proxy ayarlı değil (OZAN_PROXY_URL boş). Ozan, sunucu IP\'sini engellediği için fiyatlar gelmeyebilir.'}
            {ozanHealth.consecutive_fails ? ` • Üst üste ${ozanHealth.consecutive_fails} başarısız deneme.` : ''}
          </div>
          {ozanHealth.proxy_host ? (
            <div data-testid="ozan-proxy-host-banner" style={{ fontSize: 10.5, color: '#7f1d1d', marginTop: 4, fontFamily: 'monospace' }}>
              Yüklü proxy: <strong>{ozanHealth.proxy_host}</strong> — production'da bu host yanlışsa, deployment ortam değişkenindeki <strong>OZAN_PROXY_URL</strong> hâlâ eski/banlı proxy olabilir.
            </div>
          ) : null}
          {ozanHealth.last_error ? (
            <div data-testid="ozan-proxy-last-error" style={{ fontSize: 10.5, color: '#7f1d1d', marginTop: 3, fontFamily: 'monospace', wordBreak: 'break-word' }}>
              Son hata: {ozanHealth.last_error}
            </div>
          ) : null}
        </div>
      </div>
    )}

    {/* Otomatik fallback uyari banner'i */}
    {fallback.active && hasSource === 'altinkaynak' && (
      <div style={{ marginTop: 10, padding: '10px 12px', background: '#fef3c7', border: '1.5px solid #f59e0b', borderRadius: 6, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 18 }}>⚠️</span>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#92400e' }}>Otomatik Fallback Aktif — Şu an Ozan kullanılıyor</div>
          <div style={{ fontSize: 11, color: '#78350f', marginTop: 2 }}>
            Sebep: {fallback.reason || 'Altınkaynak yanıt vermedi'} • {Math.floor((fallback.seconds_left || 0) / 60)}dk {(fallback.seconds_left || 0) % 60}sn sonra Altınkaynak tekrar denenecek
          </div>
        </div>
      </div>
    )}
  </div>
);

export default HasSourceConfig;
